export const ACTIVITY_TYPE = {
  COMMENT: 'comment',
  MODEL: 'model',
  PIPELINE: 'pipeline',
};
